import React, { useState, useEffect } from 'react';
import LLogo from '../assets/L_logo.svg';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';

function Navbar() {
    const [nav, setNav] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [navTitle, setNavTitle] = useState('LAMINAR');

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setNavTitle('L');
            } else {
                setNavTitle('LAMINAR');
            }
        };

        const handleScroll = () => {
            const isScrolled = window.scrollY > 10;
            if (isScrolled !== scrolled) {
                setScrolled(isScrolled);
            }
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('scroll', handleScroll);
        
        handleResize(); // Set initial value
        handleScroll(); // Set initial scroll state

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [scrolled]);

    const handleNav = () => {
        setNav(!nav);
    };

    return (
        <div className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-[#0a0a16]/90 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`}>
            <div className='flex justify-between items-center h-20 mx-auto px-6 text-white max-w-[1200px]'>
                <div className='flex items-center'>
                    <div className='w-12 h-12 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-lg mr-3 flex items-center justify-center'>
                        <img src={LLogo} alt='Laminar logo' className='w-full h-full object-contain' />
                    </div>
                    <h1 className='text-xl font-bold tracking-wider hidden md:block'>
                        {navTitle}
                        <span className='text-indigo-400'> INNOVATION</span>
                    </h1>
                </div>
                
                <ul className='hidden md:flex items-center space-x-1'>
                    <li>
                        <a href="#home" className='px-4 py-2 text-gray-300 hover:text-white transition-colors'>Home</a>
                    </li>
                    <li>
                        <a href="#about" className='px-4 py-2 text-gray-300 hover:text-white transition-colors'>About</a>
                    </li>
                    <li>
                        <a href="#process" className='px-4 py-2 text-gray-300 hover:text-white transition-colors'>Process</a>
                    </li>
                    <li>
                        <a href="#contact" className='ml-2 px-5 py-2 bg-indigo-500 hover:bg-indigo-600 text-white rounded-lg transition-all'>Contact</a>
                    </li>
                </ul>
                
                <div onClick={handleNav} className={`block md:hidden cursor-pointer p-2 rounded-lg hover:bg-[#1d1c28] transition-colors ${nav ? 'fixed top-5 right-5 z-50 bg-[#1d1c28]' : ''}`}>
                    {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
                </div>
                
                {/* Mobile menu */}
                <div className={`fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300 md:hidden ${nav ? 'opacity-100 z-40' : 'opacity-0 pointer-events-none'}`}>
                    <div className={`fixed right-0 top-0 w-64 h-full bg-gradient-to-b from-[#131724] to-[#0a0a16] shadow-xl transform transition-transform duration-300 ease-in-out ${nav ? 'translate-x-0' : 'translate-x-full'}`}>
                        <div className='flex items-center p-5 border-b border-gray-800'>
                            <div className='w-10 h-10 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-lg mr-3 flex items-center justify-center'>
                                <img src={LLogo} alt='Laminar logo' className='w-full h-full object-contain' />
                            </div>
                            <h1 className='text-xl font-bold'>
                                LAMINAR<span className='text-indigo-400'> INNOVATION</span>
                            </h1>
                        </div>
                        <ul className='p-5 space-y-4'>
                            <li>
                                <a onClick={handleNav} href="#home" className='block py-2 px-4 text-gray-300 hover:text-white hover:bg-[#1d1c28] rounded-lg transition-colors'>
                                    Home
                                </a>
                            </li>
                            <li>
                                <a onClick={handleNav} href="#about" className='block py-2 px-4 text-gray-300 hover:text-white hover:bg-[#1d1c28] rounded-lg transition-colors'>
                                    About
                                </a>
                            </li>
                            <li>
                                <a onClick={handleNav} href="#process" className='block py-2 px-4 text-gray-300 hover:text-white hover:bg-[#1d1c28] rounded-lg transition-colors'>
                                    Process
                                </a>
                            </li>
                            <li>
                                <a onClick={handleNav} href="#contact" className='block py-2 px-4 text-indigo-400 hover:text-indigo-300 hover:bg-[#1d1c28] rounded-lg transition-colors'>
                                    Contact Us
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;